import { Component, OnInit, Input } from '@angular/core';
import { getTextStyle } from 'src/app/util/style-util'
import { RequirementCard } from '@bluecrew/crew-member-backend-angular-client';

@Component({
  selector: 'app-job-requirements',
  templateUrl: './job-requirements.component.html',
  styleUrls: ['./job-requirements.component.scss'],
})
export class JobRequirementsComponent implements OnInit {
  @Input() description?: String;
  @Input() provideInstructions?: boolean = false;
  @Input() requirementCards?: RequirementCard[];
  @Input() requirements?: String[];

  getTextStyle = getTextStyle;

  constructor() {}

  ngOnInit() {}
}
